import { useContext, useState } from "react";
import toast from "react-hot-toast";
import { WalletContext } from "../../scripts/context/WalletContext";
import Context from "../../scripts/context/User";
import ConfirmClaimModal from "../../components/ConfirmClaimModal";

export default function Balance() {
  const { web3, setWeb3 } = useContext(WalletContext);
  const { globalState } = useContext(Context);
  const [confirmModal, setConfirmModal] = useState(false);

  const bigNumberToFixed = (value) =>
    parseFloat(value.toString() / Math.pow(10, web3.decimals)).toFixed(4);

  const lockedBalance = () => {
    const value =
      bigNumberToFixed(web3.contracts.presale.data.claimer.balance_) -
      bigNumberToFixed(web3.contracts.presale.data.claimer.totalClaimed_) -
      bigNumberToFixed(web3.contracts.presale.data.claimer.availableClaim_);
    return value.toFixed(4) > 0 ? value.toFixed(4) : "0.0000";
  };

  const CLAIMED_BALANCE = Number(
    Number(
      bigNumberToFixed(
        web3.contracts.presale.data.claimer.totalStakingRewardClaimed_
      )
    ) +
      Number(
        bigNumberToFixed(web3.contracts.presale.data.claimer.totalClaimed_)
      )
  ).toFixed(4);

  const NEXT_UNLOCK =
    lockedBalance() === "0.0000"
      ? "All Balance Is Available"
      : new Date(
          web3.contracts.presale.data.claimer.nextUnlockDate_.toString() * 1000
        ).toLocaleString();

  const CLAIMED_PROGRESSBAR =
    bigNumberToFixed(web3.contracts.presale.data.claimer.balance_) > 0
      ? (bigNumberToFixed(web3.contracts.presale.data.claimer.totalClaimed_) /
          bigNumberToFixed(web3.contracts.presale.data.claimer.balance_)) *
        100
      : 0.0;

  const READY_TO_CLAIM = Number(
    Number(
      bigNumberToFixed(web3.contracts.presale.data.claimer.availableClaim_)
    ) +
      Number(
        bigNumberToFixed(
          web3.contracts.presale.data.claimer.availableStakingRewardAmount_
        )
      )
  ).toFixed(4);
  

  const handleClaim = async () => {
    setConfirmModal(false);
    try {
      const isClaimed = await web3.contracts.presale.contract.claimTokens({
        from: web3.account.address,
      });
      toast.promise(
        isClaimed.wait().then(async () => {
          const claimer = await web3.contracts.presale.contract.getClaimer();
          const bultTokenBalance =
            await web3.contracts.bultToken.contract.balanceOf(
              web3.account.address
            );
          setWeb3({
            ...web3,
            contracts: {
              ...web3.contracts,
              bultToken: {
                ...web3.contracts.bultToken,
                data: {
                  ...web3.contracts.bultToken.data,
                  balance: bultTokenBalance,
                },
              },
              presale: {
                ...web3.contracts.presale,
                data: {
                  ...web3.contracts.presale.data,
                  claimer,
                },
              },
            },
          });
        }),
        {
          loading: "claiming...",
          success: `You claimed tokens`,
          error: (error) => {
            console.log(error.message)
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {globalState.user.is_supporter && (
        <div className="row">
          <div className="col-md-7 mx-auto mt-0">
            <div className="d-flex align-items-center bg-light-succsess rounded p-5 mb-9 status-div">
              <span className="svg-icon svg-icon-success mr-5">
                <span className="svg-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24"></rect>
                      <circle
                        fill="#000000"
                        opacity="0.3"
                        cx="12"
                        cy="12"
                        r="10"
                      ></circle>
                      <path
                        d="M16.7689447,7.81768175 C17.1457787,7.41393107 17.7785676,7.39211077 18.1823183,7.76894473 C18.5860689,8.1457787 18.6078892,8.77856757 18.2310553,9.18231825 L11.2310553,16.6823183 C10.8654446,17.0740439 10.2560456,17.107974 9.84920863,16.7592566 L6.34920863,13.7592566 C5.92988278,13.3998345 5.88132125,12.7685345 6.2407434,12.3492086 C6.60016555,11.9298828 7.23146553,11.8813212 7.65079137,12.2407434 L10.4229928,14.616916 L16.7689447,7.81768175 Z"
                        fill="#000000"
                        fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span
                  href="#"
                  className="text-success py-1 font-size-lg font-size-status"
                >
                  Congratulations
                </span>
                <p className="fw-bold d-block z-index-1">
                  Your Account address is qualified for{" "}
                  <a
                    href="https://opentheta.io/"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "inherit",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    OpenTheta
                  </a>{" "}
                  Drop
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-md-7 mx-auto mt-0">
          <div className="card card-custom gutter-b card-stretch">
            <div
              className="card-body d-flex flex-column p-0"
              style={{ position: "relative" }}
            >
              <div className="card-spacer card-rounded flex-grow-1">
                <div className="row m-0">
                  <div className="col px-0 py-3 mr-4">
                    <div className="font-size-sm text-muted font-weight-bold">
                      Presale Claimed Balance
                    </div>
                    <div className="font-size-h6 font-weight-bolder">
                      {bigNumberToFixed(
                        web3.contracts.presale.data.claimer.totalClaimed_
                      )}{" "}
                      $BULT
                    </div>
                  </div>
                  <div className="col px-0 py-3">
                    <div className="font-size-sm text-muted font-weight-bold">
                      Next Unlock
                    </div>
                    <div className="font-size-h6 font-weight-bolder">
                      {NEXT_UNLOCK}
                    </div>
                  </div>
                </div>
                <div className="row mt-5 mx-0">
                  <div className="col px-0 py-3 mr-4">
                    <div className="font-size-sm text-muted font-weight-bold">
                      Of Presale Balance
                    </div>
                    <div className="font-size-h6 font-weight-bolder">
                      {bigNumberToFixed(
                        web3.contracts.presale.data.claimer.balance_
                      )}{" "}
                      $BULT
                    </div>
                  </div>
                  <div className="col px-3 py-3 bg-custom">
                    <div className="font-size-sm text-muted font-weight-bold">
                      Wallet Balance:
                    </div>
                    <div className="font-size-h6 text-white font-weight-bolder">
                      {bigNumberToFixed(web3.contracts.bultToken.data.balance)}{" "}
                      $BULT
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex flex-column w-100 mt-10">
                      <div className="progress progress-xs w-100">
                        <div
                          className="progress-bar bg-progress-custom"
                          role="progressbar"
                          style={{
                            width: `${CLAIMED_PROGRESSBAR}%`,
                          }}
                          aria-valuenow={CLAIMED_PROGRESSBAR}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <span className="text-muted mr-2 font-size-sm font-weight-bold">
                          {CLAIMED_PROGRESSBAR}%
                        </span>
                        <span className="text-muted font-size-sm font-weight-bold">
                          Claim From Presale Balance
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-7 mx-auto mt-0">
          <div className="">
            <div
              className="card card-body d-flex flex-column p-0 position-relative gutter-b"
              style={{ borderRadius: "18px" }}
            >
              <div className="flex-grow-1 pt-0 px-2">
                <div className="card-spacer flex-grow-1">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center mr-2">
                      <div>
                        <b className="font-size-h6 text-dark">Claimed</b>
                      </div>
                    </div>
                    <span className="font-size-h6 text-dark font-weight-bolder">
                      {CLAIMED_BALANCE}
                    </span>
                  </div>
                  <ul
                    style={{
                      paddingInlineStart: "1rem",
                    }}
                  >
                    <li className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark">
                            Claimed Presale Balance
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark">
                        {bigNumberToFixed(
                          web3.contracts.presale.data.claimer.totalClaimed_
                        )}
                      </span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark">
                            Claimed Staking Rewards
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark">
                        {bigNumberToFixed(
                          web3.contracts.presale.data.claimer
                            .totalStakingRewardClaimed_
                        )}
                      </span>
                    </li>
                  </ul>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center mr-2">
                      <div>
                        <b className="font-size-h6 text-dark ">
                          Ready To Claim
                        </b>
                      </div>
                    </div>
                    <span className="font-size-h6 text-dark font-weight-bolder">
                      {READY_TO_CLAIM}
                    </span>
                  </div>
                  <ul
                    style={{
                      paddingInlineStart: "1rem",
                    }}
                  >
                    <li className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark ">
                            Unlocked Presale Balance
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark">
                        {bigNumberToFixed(
                          web3.contracts.presale.data.claimer.availableClaim_
                        )}
                      </span>
                    </li>
                    <li className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center mr-2">
                        <div>
                          <span className="font-size-h6 text-dark ">
                            Available Staking Rewards
                          </span>
                        </div>
                      </div>
                      <span className="font-size-h6 text-dark">
                        {bigNumberToFixed(
                          web3.contracts.presale.data.claimer
                            .availableStakingRewardAmount_
                        )}
                      </span>
                    </li>
                  </ul>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center mr-2">
                      <div>
                        <b className="font-size-h6 text-dark ">
                          Locked Presale Balance
                        </b>
                      </div>
                    </div>
                    <span className="font-size-h6 text-dark font-weight-bolder">
                      {lockedBalance()}
                    </span>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-between py-4">
                    <div className="d-flex align-items-center mr-2">
                      <div>
                        <span className="font-size-h6 text-dark font-weight-bolder">
                          Total Balance
                        </span>
                      </div>
                    </div>
                    <span className="font-size-h6 text-dark font-weight-bolder">
                      {Number(
                        Number(CLAIMED_BALANCE) +
                          Number(READY_TO_CLAIM) +
                          Number(lockedBalance())
                      ).toFixed(4)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="w-100 btn btn-primary-custom"
              onClick={() => setConfirmModal(true)}
              disabled={
                bigNumberToFixed(
                  web3.contracts.presale.data.claimer.availableClaim_
                ) <= 0
              }
            >
              Claim {READY_TO_CLAIM} $BULT
            </button>
          </div>
        </div>
      </div>
      {confirmModal && (
        <ConfirmClaimModal
          setIsOpen={setConfirmModal}
          handelSubmit={handleClaim}
          title="Warning"
          body={
            <div>
              By claiming your $BULT you will no longer be eligible to receive
              your 15% APY.
            </div>
          }
        />
      )}
    </>
  );
}
